import React from "react"
import COLOR_PALETTE from "constants/color-palette"
import { WysiwygContent, StaticDealerMapWithToggle } from "components"
import { ColumnGroup, Column } from "containers"
import { H4 } from "AtomicComponents"

const MyMazdaDealerBlock = ({
  salesDealer,
  salesCTA,
  serviceCTA,
  emailCTA,
  serviceDealer,
  description,
  heading,
  defaultSelection = "Sales"
}) => {
  const dealers = [
    {
      info: {
        ...salesDealer,
        primaryCTA: {
          ...salesCTA,
          isMyMazdaLink: true
        },
        emailCTA
      },
      label: "Sales"
    },
    {
      info: {
        ...serviceDealer,
        primaryCTA: {
          ...serviceCTA,
          isMyMazdaLink: true
        },
        emailCTA
      },
      label: "Service"
    }
  ]

  if (!serviceDealer || !salesDealer) return null

  return (
    <StaticDealerMapWithToggle
      initialDepartmentIndex={dealers.map(({ label }) => label).indexOf(defaultSelection)}
      dealers={dealers}
      gtm={{
        category: "MyMazda - Dealer"
      }}>
      {({ selector, mapBlock }) => (
        <div style={{ textAlign: "center" }}>
          <ColumnGroup
            horizontalPadding
            style={{ padding: "3em 0 2em 0", background: COLOR_PALETTE.GRAY_LIGHTER }}>
            <Column textAlign="center">
              {heading && <H4>{heading}</H4>}
              {selector}
              {description && <WysiwygContent xmlString={description} />}
            </Column>
          </ColumnGroup>
          {mapBlock}
        </div>
      )}
    </StaticDealerMapWithToggle>
  )
}


export default MyMazdaDealerBlock



// WEBPACK FOOTER //
// ./src/blocks/mymazda/dealer-block/index.jsx